export const handleScroll = () => {
  const nowPlayingHeader = document.getElementById('now-playing-header');
  const scheduledHeader = document.getElementById('scheduled-header');
  const comingSoonGalleryHeader = document.getElementById('coming-soon-gallery-header');
  const expiredHeader = document.getElementById('expired-header');
  const expiredGalleryHeader = document.getElementById('expired-gallery-header');

  const nowPlayingSection = document.getElementById('now-playing-section');
  const scheduledSection = document.getElementById('scheduled-section');
  const expiredSection = document.getElementById('expired-section');

  // Get the height of the header
  const headerHeight = document.querySelector('.digital-signage-header').offsetHeight;

  // Get the positions, but subtract the header height
  let nowPlayingPosition;
  let scheduledPosition;
  let expiredPosition

  nowPlayingSection ?
    nowPlayingPosition = nowPlayingSection.getBoundingClientRect().top - headerHeight :
    nowPlayingPosition = null;

  scheduledSection ?
    scheduledPosition = scheduledSection.getBoundingClientRect().top - headerHeight :
    scheduledPosition = null;

  expiredSection ?
    expiredPosition = expiredSection.getBoundingClientRect().top - headerHeight :
    expiredPosition = null;


  if (expiredPosition && expiredPosition <= 95) {
    nowPlayingHeader.style.display = 'none';
    scheduledHeader.style.display = 'none';
    expiredHeader.style.display = 'block';
    expiredGalleryHeader.style.display = 'none';
    if (scheduledPosition) {
      comingSoonGalleryHeader.style.display = 'block';
      scheduledHeader.style.display = 'none';
    }
  } else if (scheduledPosition && scheduledPosition <= 95) {
    nowPlayingHeader.style.display = 'none';
    scheduledHeader.style.display = 'block';
    comingSoonGalleryHeader.style.display = 'none';
    if (expiredPosition) {
      expiredGalleryHeader.style.display = 'block';
      expiredHeader.style.display = 'none';
    }
  } else if (nowPlayingPosition && nowPlayingPosition <= 95) {
    nowPlayingHeader.style.display = 'block';
    if (expiredPosition) {
      expiredHeader.style.display = 'none';
      expiredGalleryHeader.style.display = 'block';
    }
    if (scheduledPosition) {
      comingSoonGalleryHeader.style.display = 'block';
      scheduledHeader.style.display = 'none';
    }
  }
};



